import { ComboDto } from "src/app/dtos/combo-dto";

export class GenericModalData {
  title: string;
  question: string;
  justifications: ComboDto[];
}
